import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useIsMobile from '../../../hooks/use-is-mobile';
import InteractiveQuizMobile from '../../../images/interactive-quiz-mobile.png';
import InteractiveQuiz from '../../../images/interactive-quiz.png';
import { world } from '../../../languages';
import { AVAILABLE_WORLDS } from '../../../languages/constants';
import qualityEvents from '../../../services/quality-events';
import isUITest from '../../../utils/is-ui-test';
import SharedModal from '../../shared-modal/shared-modal';
import './interactive-quiz-announcement-popup.scss';

const localstoragePopupName = 'interactiveQuizAnnouncementPopup';

const worlds = {
    [AVAILABLE_WORLDS.DE]: {
        closeBtn: 'Schließen',
        learnMoreBtn: 'Mehr erfahren',
        title: 'Jetzt neu: Interactive Quizze!',
        subtitle:
            'Autor*innen aufgepasst: Erstelle und veröffentliche interaktive Quizze - <b>und gewinne tolle Preise!</b> 🥳'
    }
};

const buttonConfig = [
    {
        action: () => {
            window.storage.setItem(localstoragePopupName, 1);
            window.location.reload();
        },
        className: 'quiz-btn transparent',
        text: <>{worlds[AVAILABLE_WORLDS.DE].closeBtn}</>
    },
    {
        action: () => {
            qualityEvents.track({
                extra: JSON.stringify({
                    user_id: window.storage.getItem('userId')
                }),
                type: 'interactive-quiz-announcement-popup'
            });
            window.storage.setItem(localstoragePopupName, 1);
            window.location.href = `${process.env.REACT_APP_FRONT_URL}/de/post/11358`;
        },
        className: 'quiz-btn yellow',
        text: <>{worlds[AVAILABLE_WORLDS.DE].learnMoreBtn}</>
    }
];

const InteractiveQuizAnnouncementPopup = () => {
    const user = useSelector((state: RootState) => state.main.user);
    const [showModal, setShowModal] = useState(false);
    const isMobile = useIsMobile(767);

    // show modal
    useEffect(() => {
        const wasShown = window.storage.getItem(localstoragePopupName);
        const isAuthor = user?.details?.totalMaterials > 0;
        const currentDate = new Date();
        const startDate = new Date('2024-07-25T08:00:00');
        const endDate = new Date('2024-07-28T23:59:59');
        const isBetweenDateRange = currentDate >= startDate && currentDate <= endDate;

        if (!wasShown && !isUITest() && isAuthor && isBetweenDateRange && world === AVAILABLE_WORLDS.DE) {
            setShowModal(true);
        }
    }, [user]);

    const handleClose = () => {
        window.storage.setItem(localstoragePopupName, 1);
        setShowModal(false);
    };

    const body = (
        <div>
            <img className='quiz-img' src={isMobile ? InteractiveQuizMobile : InteractiveQuiz} alt='interactive quiz' />
            <div
                className='quiz-popup-title text-center'
                dangerouslySetInnerHTML={{ __html: worlds[AVAILABLE_WORLDS.DE].title }}
            />
            <div
                className='quiz-popup-subtitle text-center'
                dangerouslySetInnerHTML={{ __html: worlds[AVAILABLE_WORLDS.DE].subtitle }}
            />
        </div>
    );

    return showModal ? (
        <SharedModal
            body={body}
            btnConfig={buttonConfig}
            dialogClassName='interactive-quiz-announcement-popup'
            title={<></>}
            onClose={handleClose}
        />
    ) : null;
};

export default InteractiveQuizAnnouncementPopup;
